import { TextField } from '@material-ui/core';
import React from 'react';
import { useGlobalState } from 'store/reducers/reducer';
export const UserEmail = () => {
    const { state } = useGlobalState();
    return (React.createElement("form", { 
        // onSubmit={onSubmitName}
        autoComplete: "off", className: "g-form", noValidate: true },
        React.createElement("span", { className: "title" }, "Email"),
        React.createElement(TextField, { className: "u-margin-bottom-small", defaultValue: state.user?.email, 
            /*
             * error={lastName === null}
             * onChange={handleChangeLastName}
             */
            disabled: true, label: "Email", required: true })));
};
